"use client";

import { createContext, useContext } from "react";

import type {
  WriterAdapterMode,
  WriterFeatureFlags,
} from "./types";
import { DEFAULT_WRITER_FEATURE_FLAGS } from "./feature-flags";

export type WriterRuntimeConfig = {
  adapterMode: WriterAdapterMode;
  featureFlags: WriterFeatureFlags;
};

const defaultWriterRuntimeConfig: WriterRuntimeConfig = {
  adapterMode: "http",
  featureFlags: { ...DEFAULT_WRITER_FEATURE_FLAGS },
};

const WriterRuntimeConfigContext = createContext<WriterRuntimeConfig>(defaultWriterRuntimeConfig);

export function WriterRuntimeConfigProvider({
  children,
  value,
}: React.PropsWithChildren<{ value: WriterRuntimeConfig }>) {
  return (
    <WriterRuntimeConfigContext.Provider value={value}>
      {children}
    </WriterRuntimeConfigContext.Provider>
  );
}

export function useWriterRuntimeConfig() {
  return useContext(WriterRuntimeConfigContext);
}
